import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import api from "@/app/api";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import {
  recipeService,
  type Recipe,
} from "@/app/services/generated/recipev2Service";

// Singleton cache store
const recipeCacheStore = new EntityCacheStore<Recipe>(
  EnumCacheEntityType.recipe,
  async () => recipeService.getAllRecipes(api.tenantId)
);

// Ephemeral reader
export default class RecipesCache extends EntityWithGuidKeyCache<Recipe> {
  constructor() {
    super(recipeCacheStore, (x) => x.header.id);
  }

  public get allMaintenanceRecipes() {
    return Object.freeze(
      [...this.allReactive.value].filter((x) =>
        x.header.processType.isMaintenance()
      ) as readonly Readonly<Recipe>[]
    );
  }
}
